(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	// Parse query string
	var parseQueryString = function (query) {
		var parts = query.split('&');
		var vars = {};

		parts.forEach(function (part) {
			var innerParts = part.split('=');
			var key = decodeURIComponent(innerParts[0]);
			var val = decodeURIComponent(innerParts[1] || '');

			if (val === 'null') {
				val = null;
			}

			vars[key] = val;
		});

		return vars;
	};

	// Parse query
	var query = null;

	if (window.location.hash.length) {
		query = parseQueryString(window.location.hash.substr(1));
	}

	// Util functions
	var isCitySelected = function () {
		return query !== null && query.city !== null;
	};

	var isActivitySelected = function () {
		return query !== null && query.activity !== null;
	};

	var isFormLoaded = function () {
		return $('div.wb-loadingdiv').length && $('div.wb-loadingdiv').css('display') === 'none';
	};

	// If no city is selected on page load - expand the city panel
	// else if no activity is selected - expand the acticity panel
	// else do nothing
	// NOTE: Disabled as of 2022-04-04
	/* var checkLoad = setInterval(function () {
		if (isFormLoaded()) {
			clearInterval(checkLoad);

			if (!isCitySelected()) {
				$('#filter-1 > [data-toggle="collapse"]').click();
			}
			else if (!isActivitySelected()) {
				$('#filter-2 > [data-toggle="collapse"]').click();
			}
		}
	}, 500); */

	// Open second filter on city select
	$('#metodika-booking').on('click', '#cities button', function () {
		$('#filter-2 > [data-toggle="collapse"]').click();
	});
})();
